// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1__vb","cls2":"Unibrow-cls2_K3f Unibrow-cls1__vb"};